<template>
  <div
    v-bind="containerAttrs"
    :class="[
      bem.b(),
      bem.is(getPagingStyle),
      bem.is(isGray ? 'gray-pagination' : ''),
    ]"
  >
    <div v-if="$slots.side" :class="bem.e('side')">
      <slot name="side"></slot>
    </div>
    <div :class="[bem.e('pagination'), bem.m(getPagingOrientation)]">
      <a-pagination
        v-bind="componentAttrs"
        :show-total="isShowTotal ? handleShowTotal : undefined"
      >
        <template #itemRender="{ page, type, originalElement }">
          <!-- 自定义插槽 -->
          <slot
            v-if="$slots.itemRender"
            name="itemRender"
            v-bind="{ page, type, originalElement }"
          />

          <!-- 内置插槽 -->
          <template v-else>
            <ll-button
              v-if="type === 'prev' && prevIcon"
              type="link"
              :class="['ant-pagination-item-link', bem.m('custom-prev')]"
              :icon="{ iconName: prevIcon }"
            />
            <ll-button
              v-else-if="type === 'next' && nextIcon"
              type="link"
              :class="['ant-pagination-item-link', bem.m('custom-next')]"
              :icon="{ iconName: nextIcon }"
            />

            <component :is="originalElement" v-else></component>
          </template>
        </template>
      </a-pagination>
    </div>
  </div>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { omit } from 'lodash-es'
import { computed, useAttrs } from 'vue'
import { paginationProProps } from './pagination-pro'

defineOptions({ name: 'LlPaginationPro', inheritAttrs: false })

const props = defineProps(paginationProProps)

const bem = createNamespace('pagination-pro')

const attrs = useAttrs()

// 容器样式
const containerAttrs = computed(() => ({
  class: attrs.class as any,
  style: attrs.style as any,
}))

// 组件属性
const componentAttrs = computed(() => {
  return { ...omit(attrs, ['class', 'style']) }
})

const getPagingStyle = computed(() => {
  switch (props.pagingStyle) {
    case 'simple':
      return 'simple'
    case 'solid':
      return 'solid'
    case 'outline':
      return 'outline'
    default:
      return 'outline'
  }
})

const getPagingOrientation = computed(() => {
  switch (props.alignment) {
    case 'left':
      return 'left'
    case 'center':
      return 'center'
    case 'right':
      return 'right'
    default:
      return 'right'
  }
})

const handleShowTotal = (total: number, range: number[]) => {
  if (typeof props.showTotal === 'function') {
    return props.showTotal(total, range)
  } else {
    return `共 ${total} 条`
  }
}
</script>
